import {
  CustomEvent,
  CustomEventsResponse as Response,
  UpdateCustomEventParams,
  convertCustomEvents,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

type Variables = UpdateCustomEventParams

export function useUpdateCustomEvent() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateCustomEvent,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(() => null)
    },
  })

  async function updateCustomEvent(
    updateParams: Variables
  ): Promise<Array<CustomEvent>> {
    const response = await server.put<Response.CustomEvent[]>(
      `v2/event/custom/${updateParams.id}?update_type=ALL`,
      {
        summary: updateParams.summary,
        description: updateParams.description,
        start_date: updateParams.startDate,
        end_date: updateParams.endDate,
        recurring: updateParams.recurring,
        frequency: updateParams.frequency,
        deleted: updateParams.deleted,
        event_type: updateParams.eventType,
        visible_to_roles: updateParams.visibleToRoles,
        all_day: updateParams.allDay,
        block_rto: updateParams.blockRto,
        selected_store_ids: updateParams.selectedStoreIds,
        deselected_store_ids: updateParams.deselectedStoreIds,
      }
    )
    return convertCustomEvents(response)
  }
}
